const DownloadFile = ({ file, fileName }) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);

  try {
    link.click();
  } finally {
    link.remove();
    // Allow the browser to start the download before releasing the file URL.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};

export { DownloadFile };
